// Color assignment utilities

import { HOLIDAY_COLORS } from './constants';

/**
 * Get calendar color based on index using predefined palette
 */
export function getCalendarColor(calendarIndex: number): string {
  return HOLIDAY_COLORS[calendarIndex % HOLIDAY_COLORS.length];
}
